"use client";

// src/actions.ts
import {
  connect,
  disconnect,
  fetchBalance,
  fetchBlockNumber,
  fetchEnsAddress,
  fetchEnsAvatar,
  fetchEnsName,
  fetchEnsResolver,
  fetchFeeData,
  fetchToken,
  fetchTransaction,
  getAccount,
  getContract,
  getNetwork,
  getPublicClient,
  getWalletClient,
  getWebSocketPublicClient,
  multicall,
  prepareSendTransaction,
  prepareWriteContract,
  readContract,
  readContracts,
  sendTransaction,
  signMessage,
  signTypedData,
  switchNetwork,
  waitForTransaction,
  watchAccount,
  watchBlockNumber,
  watchContractEvent,
  watchMulticall,
  watchNetwork,
  watchPendingTransactions,
  watchPublicClient,
  watchReadContract,
  watchReadContracts,
  watchWalletClient,
  watchWebSocketPublicClient,
  writeContract
} from "@wagmi/core";
export {
  connect,
  disconnect,
  fetchBalance,
  fetchBlockNumber,
  fetchEnsAddress,
  fetchEnsAvatar,
  fetchEnsName,
  fetchEnsResolver,
  fetchFeeData,
  fetchToken,
  fetchTransaction,
  getAccount,
  getContract,
  getNetwork,
  getPublicClient,
  getWalletClient,
  getWebSocketPublicClient,
  multicall,
  prepareSendTransaction,
  prepareWriteContract,
  readContract,
  readContracts,
  sendTransaction,
  signMessage,
  signTypedData,
  switchNetwork,
  waitForTransaction,
  watchAccount,
  watchBlockNumber,
  watchContractEvent,
  watchMulticall,
  watchNetwork,
  watchPendingTransactions,
  watchPublicClient,
  watchReadContract,
  watchReadContracts,
  watchWalletClient,
  watchWebSocketPublicClient,
  writeContract
};
